/** Raiz del PWA: Query + Router + sesion movil. */
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { queryClient } from '@/config/queryClient';
import { MobileAuthProvider } from '@/state/MobileAuthContext';
import { MonetaryPrecisionProvider } from '@/state/MonetaryPrecisionContext';
import { MobileRoutes } from '@/routes/MobileRoutes';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <MobileAuthProvider>
          <MonetaryPrecisionProvider>
            <MobileRoutes />
          </MonetaryPrecisionProvider>
          <Toaster position="top-center" />
        </MobileAuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
